import { useMemo, useCallback } from "react";
import { OrderedMap } from "immutable";
import { useQueryParam, ArrayParam } from "routing/QueryParams";
const useUrlQueryFilters = () => {
  const [pureUrlQueryFilters, setPureUrlQueryFilters] = useQueryParam("filters", ArrayParam);
  const filtersFromQuery = useMemo(
    () => (pureUrlQueryFilters != null ? pureUrlQueryFilters : []).reduce((col, filter) => {
      var _a;
      const [attributeId, filterValue] = filter.split(/=(.*)/);
      return col.set(attributeId, [...(_a = col.get(attributeId)) != null ? _a : [], filterValue]);
    }, OrderedMap()),
    [pureUrlQueryFilters]
  );
  const setFilterValues = useCallback(
    (newFilters) => {
      const newPureUrlQueryFilters = newFilters.entrySeq().reduce((col, [attributeId, filters]) => [...col, ...filters.map((value) => `${attributeId}=${value}`)], []);
      setPureUrlQueryFilters(newPureUrlQueryFilters);
    },
    [setPureUrlQueryFilters]
  );
  return [filtersFromQuery, setFilterValues];
};
export default useUrlQueryFilters;
